import { css } from '@genesislcap/web-core';
import { labelStyles } from '../../../../styles';

export const dealConditionsFormStyles = css`
  :host {
    max-height: 100%;
    overflow-x: visible;
    overflow-y: auto;
  }

  ${labelStyles}
  .order-description {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    white-space: nowrap;

    .order-description-item {
      text-align: right;
      padding: 5px;
      border-radius: 3px;
    }

    .order-description-item.text {
      text-align: left;
    }

    .label {
      margin-bottom: 5px;
    }
  }

  .container {
    display: flex;
    flex-direction: column;
  }

  .form {
    display: flex;
    align-items: stretch;

    .form-column {
      flex: 1 1 50%;
    }

    .form-column:first-child {
      border-right: 1px solid var(--neutral-stroke-divider-rest);
      padding-right: 15px;
      margin-right: 15px;
    }

    .form-divider {
      height: 100%;
      padding: 0 10px;
    }
  }

  .form-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;

    .form-item-input {
      flex: 1;
      --warning-border-color: #ffb660;

      rapid-select,
      rapid-text-field,
      rapid-number-field {
        display: block;
        width: 100%;
      }

      rapid-select {
        min-width: auto;
      }

      rapid-select[open]::part(control) {
        height: 100%;
      }

      rapid-select::part(listbox){
        top: 100% !important;
        bottom: auto !important;
        margin-top: 2px !important;
        padding: 0;
      }

      &.error {
        --error-border-color: var(--error-color, #ff4444);

        rapid-number-field::part(control),
        rapid-text-field::part(control),
        rapid-select::part(control) {
          border-color: var(--error-border-color);
          outline: none;
        }

        rapid-number-field::part(root),
        rapid-text-field::part(root),
        rapid-select::part(root) {
          border-color: var(--error-border-color);
        }
      }

      &.warning {
        rapid-number-field::part(control),
        rapid-text-field::part(control),
        rapid-select::part(control) {
          border-color: var(--warning-border-color);
          outline: none;
        }

        rapid-number-field::part(root),
        rapid-text-field::part(root),
        rapid-select::part(root) {
          border-color: var(--warning-border-color);
        }
      }

      .error-message {
        font-size: 11px;
        margin-top: 4px;
        font-weight: 400;
        height: 13px;
        line-height: 16px;
        overflow: hidden;
        width: 100%;
        max-width: 100%;
        word-wrap: break-word;
        white-space: normal;
      }

      &.error .error-message {
        color: var(--error-color, #ff4444);
      }

      &.warning .error-message {
        color: var(--warning-border-color);
      }
    }

    .form-item-input.flex-maturity-input {
      position: relative;
      overflow: visible;

      rapid-text-field:not([disabled])::part(control) {
        cursor: pointer;
      }
    }

    rapid-text-area {
      flex: 1;
    }

    rapid-select::part(control),
    rapid-select::part(root),
    rapid-text-field::part(control),
    rapid-text-field::part(root),
    rapid-number-field::part(root),
    rapid-number-field::part(control) {
      height: 32px;
    }

    .label {
      padding-right: 5px;
      width: 100px;
      margin-top: 6px;
    }
  }
`;
